module.exports = __webpack_public_path__ + "img/small.e90f23a5.svg";